import type { ReactNode } from "react";

interface SidepanelProps {
    children: ReactNode | ReactNode[];
}

export const Sidepanel = (props: SidepanelProps) => {
    return (
        <>
            <div className="w-[450px]"></div>
            <div className="fixed right-0 h-screen w-[450px] bg-white drop-shadow">
                {props.children}
            </div>
        </>
    );
};
